module.exports = "../fonts/vendor/primevue/resources/themes/lara-light-indigo/Inter-SemiBold.woff?cca62d21c8c555c392e580a52e0d4426";